module.exports = __webpack_public_path__ + "static/media/error.67a3a5b8.svg";